(() => {
  const applyInventoryLayout = (info, sourceQuantity = null) => {
    const row = info.querySelector(':scope > .lch-product-purchase-row');
    if (!row) return;
    const quantity = row.querySelector('.product-form__quantity');
    if (!quantity) {
      row.classList.add('lch-single-quantity');
      return;
    }
    const source = sourceQuantity || quantity;
    const tracked = source.dataset.lchInventoryTracked === 'true';
    const available = Number(source.dataset.lchInventoryQuantity);
    const hideQuantity = tracked && Number.isFinite(available) && available <= 1;
    row.classList.toggle('lch-single-quantity', hideQuantity);
  };

  const buildRow = (root = document) => {
    root.querySelectorAll('[id^="ProductInfo-"]').forEach((info) => {
      const title = info.querySelector(':scope > .product__title');
      const quantity = info.querySelector(':scope > .product-form__quantity, :scope > .lch-product-purchase-row > .product-form__quantity');
      const price = info.querySelector(':scope > .lch-product-purchase-price, :scope > .lch-product-purchase-row > .lch-product-purchase-price');
      const buy = info.querySelector(':scope > .lch-product-purchase-buy, :scope > .lch-product-purchase-row > .lch-product-purchase-buy');
      const share = info.querySelector(':scope > share-button, :scope > .lch-product-purchase-row > share-button');
      const countdown = info.querySelector(':scope > [data-lch-shipping-countdown], :scope > .lch-product-purchase-row > [data-lch-shipping-countdown]');
      if (!title || !price || !buy) return;

      let row = info.querySelector(':scope > .lch-product-purchase-row');
      if (!row) {
        row = document.createElement('div');
        row.className = 'lch-product-purchase-row';
      }
      if (title.nextElementSibling !== row) title.after(row);
      row.append(price);
      if (share) {
        share.classList.add('lch-product-purchase-share');
        row.append(share);
      }
      if (quantity) row.append(quantity);
      if (countdown) row.append(countdown);
      row.append(buy);
      row.classList.toggle('lch-has-share', Boolean(share));
      const variantPicker = info.querySelector(':scope > variant-selects, :scope > variant-radios');
      if (variantPicker && row.nextElementSibling !== variantPicker) row.insertAdjacentElement('afterend', variantPicker);
      applyInventoryLayout(info);
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => buildRow(document), { once: true });
  } else {
    buildRow(document);
  }

  document.addEventListener('shopify:section:load', (event) => buildRow(event.target));
  document.addEventListener('product-info:loaded', (event) => buildRow(event.target));

  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined' && PUB_SUB_EVENTS.variantChange) {
    subscribe(PUB_SUB_EVENTS.variantChange, (event) => {
      const sectionId = event?.data?.sectionId;
      const html = event?.data?.html;
      if (!sectionId || !html) return;
      const info = document.getElementById(`ProductInfo-${sectionId}`);
      const sourceQuantity = html.getElementById(`Quantity-Form-${sectionId}`);
      if (info && sourceQuantity) applyInventoryLayout(info, sourceQuantity);
      const countdown = info?.querySelector('[data-lch-shipping-countdown]');
      const sourceCountdown = html.querySelector('[data-lch-shipping-countdown]');
      if (countdown && sourceCountdown) {
        countdown.dataset.available = sourceCountdown.dataset.available;
        countdown.dataset.requiresShipping = sourceCountdown.dataset.requiresShipping;
        window.LCHUpdateShippingCountdown?.();
      }
    });
  }
})();
